import {
	reduce,
	merge,
	keys
} from "lodash";
import { defaultPermissions } from "./basePermissions.const";

const rolePermissionTransforms = {
	"USER": {
	},
	"SUSER": {
	},
	"AGENT": {
		"Reporting": {
			"Actions": {
				"CanViewExports": true
			}
		},
		"Administration": {
			"IsDisabled": false,
			"User": {
				"IsDisabled": false,
				"Actions": {
					"CanSetSecurity": true
				}
			},
			"Entity": {
				"IsDisabled": false,
				"Actions": {
					"CanImport": true,
					"CanCreate": true
				}
			}
		}
	},
	"SYSADMIN": {
		"Settings": {
			"IsDisabled": false
		},
		"Reporting": {
			"Actions": {
				"CanViewExports": true
			}
		},
		"Administration": {
			"IsDisabled": false,
			"User": {
				"IsDisabled": false,
				"Actions": {
					"CanImpersonate": true,
					"CanSetSecurity": true
				}
			},
			"Entity": {
				"IsDisabled": false,
				"Actions": {
					"CanImport": true,
					"CanCreate": true
				}
			},
			"Analytics": {
				"IsDisabled": false
			},
			"Operations": {
				"IsDisabled": false
			}
		}
	}
};


const allRolePermissions = reduce(keys(rolePermissionTransforms), (acc, role) => {
	acc[role] = merge({}, defaultPermissions, rolePermissionTransforms[role]);

	return acc;
}, {});

export const defaultRolePermissions = allRolePermissions;
